import React from 'react'
export default React.createContext({
  user: false,
  signIn: () => {},
  signOut: () => {}
})
